import { render } from "./CoinflipChart.vue?vue&type=template&id=3348986b"
import script from "./CoinflipChart.vue?vue&type=script&lang=js"
export * from "./CoinflipChart.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__